module.exports = global["window"]["$"] = require("-!/home/circleci/repo/node_modules/expose-loader/index.js?window.jQuery!/home/circleci/repo/bower_components/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./bower_components/jquery/dist/jquery.js
// module id = 2
// module chunks = 0 1